// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "volumetricLightingRenderVolumeVertexShader";
const shader = `#include<sceneUboDeclaration>
#include<meshUboDeclaration>
attribute position : vec3f;
varying vWorldPos: vec4f;
@vertex
fn main(input : VertexInputs)->FragmentInputs {let worldPos=mesh.world*vec4f(vertexInputs.position,1.0);vertexOutputs.vWorldPos=worldPos;vertexOutputs.position=scene.viewProjection*worldPos;}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("./ShadersInclude/sceneUboDeclaration"),
    import("./ShadersInclude/meshUboDeclaration")
]));
/** @internal */
export const volumetricLightingRenderVolumeVertexShaderWGSL = { name, shader };
